import React from 'react'
import { Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const CategoryCard = ({ e , background, img, title }) => {
    return (
        <Col xs="6" sm="4" md="4" lg="2" className="my-4 d-flex justify-content-around ">
            <div className="allCard mb-3 CardCate ">
                <div
                    className="categoty-card "
                    style={{ backgroundColor: `${background}` }}></div>
                <Link to={`/product/category/${e&& e._id}`} ><img alt="zcv" src={img} className="categoty-card-img" /></Link>
                <p className="categoty-card-text my-2">{title}</p>
            </div>
        </Col>
    )
}

export default CategoryCard
